export default __webpack_public_path__ + "static/media/info-utili.a5488c29.jpg";